export default {
	name: "AuthenticatableMixin",

	computed: {
		isAuthenticated() {
			return this.$store.getters["auth/isAuthenticated"];
		}
	},

	created() {
		if ( !this.isAuthenticated ) {
			this.$http.post( "kiosk/auth", { key: this.$route.query.key } )
			.catch( () => this.$router.push( { name: "login" } ) );
		}
	}
};
